import React from 'react'
import lodash from 'lodash'

import Alert from '../../../../../1stlog-ui/src/components/Alert'
import { useField } from '../../../../../1stlog-ui/src/components/Field'

type TLabelActivatedMessageProps = {}

const LabelActivatedMessage = (props: TLabelActivatedMessageProps): React.ReactElement => {
  const {} = props

  const isLabelActivated = useField('isLabelActivated')

  return (
    isLabelActivated && (
      <Alert info>
        {i18n.t(
          'retoure_label_activated_message',
          'Die Versenderinformationen wurden vom aktivierten Label übernommen. Bitte füllen Sie die Angaben zum Coli aus.'
        )}
      </Alert>
    )
  )
}

export default LabelActivatedMessage
